import { Component, EventEmitter, Input, Output } from "@angular/core";
export interface FilterOption {
	value: string;
	label: string;
	inactiveClass: string;
	activeClass: string;
	inactiveTextClass: string;
	activeTextClass: string;
}
@Component({
	selector: "app-filter-color",
	templateUrl: "./filter-color.component.html",
	styleUrls: ["./filter-color.component.scss"],
})
export class FilterColorComponent {
	@Input() filters: FilterOption[] = [];
	@Input() activeFilter: string | null = null;
	@Output() filterChanged = new EventEmitter<string>();

	protected applyFilter(filterValue: string) {
		this.filterChanged.emit(filterValue);
	}

	protected getFilterClasses(filter: FilterOption) {
		return {
			[filter.inactiveClass]: this.activeFilter !== filter.value,
			[filter.activeClass]: this.activeFilter === filter.value,
			[filter.inactiveTextClass]: this.activeFilter !== filter.value,
			[filter.activeTextClass]: this.activeFilter === filter.value,
		};
	}
}
